import { Injectable } from "@angular/core";
import { PlacardDetailsSession } from "../../api/models/placardDetailsSession";
import { PlacardDetailsRequest, PlacardEditionRequest } from "../../api/models/placardEdit";
import { A4_PLACARD_SIZE_KEY, CONTINENTAL_REGIONS, PLACARD_SIZE_KEY, PLACARD_TYPE_KEY } from "../../constants/upplm.constants";
import { KeyValue } from "../../interface/upplm.placard";
import { PlacardDetails } from "../../interface/upplm.placardInformation";
import { TranslateDataPipe } from "../../pipes/translation.pipe";

@Injectable()

export class PlacardDetailsHelperService {

    constructor(private _translateData: TranslateDataPipe) { }

    preparePlacardDetailsForEdit(placardDetails: PlacardDetails, globalRegion: string = 'NA'): PlacardDetailsSession {
        let placardDetailsSession = new PlacardDetailsSession();

        placardDetailsSession.placardSizeKey = globalRegion === CONTINENTAL_REGIONS.NA ? PLACARD_SIZE_KEY.find(size => size.value === placardDetails.placardSize).key : A4_PLACARD_SIZE_KEY;
        placardDetailsSession.placardTypekey = PLACARD_TYPE_KEY.find(type => type.value === placardDetails.placardType).key;
        placardDetailsSession.togglePlacard = this.getMultiOfficeValue(placardDetails.locationType);
        return placardDetailsSession;
    }

    prepareSaveEditionRequest(editedPlacardDetails: PlacardDetailsSession): PlacardEditionRequest {
        let placardEditionRequest = new PlacardEditionRequest();
        let placardDetails = new PlacardDetailsRequest();
        placardDetails.placardSizeKey = editedPlacardDetails.placardSizeKey;
        placardDetails.placardTypeKey = editedPlacardDetails.placardTypekey;
        placardDetails.locationType = this.getLocationType(editedPlacardDetails.togglePlacard);
        placardEditionRequest.placardDetails = placardDetails;
        return placardEditionRequest;
    }

    getMultiOfficeValue(value: string): boolean {
        if (value === 'Single Location') return false;
        return true;
    }

    getMultiOfficeValueToShow(value: boolean): string {
        if (value) return this._translateData.transform('upplm.common.yes');
        return this._translateData.transform('upplm.common.no');
    }

    getLocationType(value: boolean): string {
        if (value) return '1';
        return '0';
    }

    getPlacardType(shipmentTypes: KeyValue[]): KeyValue[] {
        let translatedShipments: KeyValue[] = [];
        shipmentTypes.forEach(shipmentType => {
            let keyvalue = new KeyValue();
            keyvalue.value = this.getPlacardTypeDescription(shipmentType.value);
            keyvalue.key = shipmentType.key;
            translatedShipments.push(keyvalue);
        });
        return translatedShipments;
    }

    getPlacardTypeDescription(valueType: string): string {
        if (valueType === 'LAB SPECIMEN') return this._translateData.transform('upplm.placarddetails.labspecimen').toUpperCase();
        if (valueType === 'NON-LAB') return this._translateData.transform('upplm.placarddetails.nonlab').toUpperCase();
        return '';
    }

    // TODO: Replace with new service

    getPlacardSize(placardSizes: KeyValue[]): KeyValue[] {
        let translatedPlacardSize: KeyValue[] = [];
        placardSizes.forEach(placardSize => {
            let keyvalue = new KeyValue();
            keyvalue.key = placardSize.key;
            keyvalue.value = this.getPlacardSizeDescription(placardSize.value);
            translatedPlacardSize.push(keyvalue);
        });
        return translatedPlacardSize;
    }

    getPlacardSizeDescription(value: string): string {
        if (value.includes('Portrait')) {
            return value.replace("Portrait", this._translateData.transform('upplm.placarddetails.portrait'));
        }
        if (value.includes('Landscape')) {
            return value.replace("Landscape", this._translateData.transform('upplm.placarddetails.landscape'))
        }
    }
}